import type {
  AdminPaginatedEnvelope,
  BusinessLimit,
  BusinessLimitField,
  BusinessLimitTags,
} from '@/types';
import type {AfriexQueryParams} from '@/types/AfriexQueryParams';

export type LimitListProps<T> = {
  /**
   * Whatever the fetchers caught. Was `typeof Error | null`, which is the
   * `Error` *constructor* rather than an error instance.
   */
  error: unknown;
  isLoading: boolean;
  isSearch?: boolean;
  isPageReset?: boolean;
  pageInfo: {
    total: number;
    page: number;
    summary?: AdminPaginatedEnvelope<T[]>['summary'];
  };
  list: T[];
  fetchList: (params: AfriexQueryParams) => void;
  setPage: (page: number) => void;
  filterCount: number;
  currentFilters: AfriexQueryParams;
  filtersToApply: AfriexQueryParams;
  clearFilters: () => void;
  selectAppliedFilters: (
    name: string,
    value: string | Date | number | undefined,
  ) => void;
  handleApplyFilters: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
  handleAutoComplete: (t: string) => void;
};

export enum LimitActionType {
  UPDATE_LIMIT = 'UPDATE_LIMIT',
  ADD_TAG = 'ADD_TAG',
  UPDATE_TAG = 'UPDATE_TAG',
  REMOVE_TAG = 'REMOVE_TAG',
  SET_LIMIT_MAP = 'SET_LIMIT_MAP',
}

interface UpdateLimitAction {
  type: LimitActionType.UPDATE_LIMIT;
  payload: Partial<BusinessLimit>;
}

interface AddLimitTagAction {
  type: LimitActionType.ADD_TAG;
  payload: BusinessLimitTags;
}
interface UpdateLimitTagAction {
  type: LimitActionType.UPDATE_TAG;
  payload: BusinessLimitTags;
}

interface RemoveLimitTagAction {
  type: LimitActionType.REMOVE_TAG;
  payload: BusinessLimitField;
}
interface SetLimitMapAction {
  type: LimitActionType.SET_LIMIT_MAP;
  payload: BusinessLimit['limit'];
}

export type LimitAction =
  | UpdateLimitAction
  | AddLimitTagAction
  | UpdateLimitTagAction
  | RemoveLimitTagAction
  | SetLimitMapAction;
